import { Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';

import { DataService } from 'src/app/shared/network/data.service';
import { ColumnForSelection } from 'src/app/shared/import/column-for-selection';
import { BaseColumnSelectComponent } from '../base-column-selection.component';
import { ProjectService } from 'src/app/shared/project/project.service';
import { ImportProgressService } from 'src/app/shared/import/import-progress.service';
import { NotificationService } from 'src/app/shared/notificaton.service';
import { ImportStep } from '../../import-step';
import { ImportStepState } from '../../base-import-step.component';
import { OutcomeColumnSelectionModel } from './outcome-column-selection-model';
import { ColumnScrollService } from '../../column-scroll.service';

@Component({
    selector: 'outcome-column-selection',
    templateUrl: './outcome-column-selection.component.html',
    styleUrls: ['../../general.scss', '../column-selection.scss']
})
export class OutcomeColumnSelectComponent extends BaseColumnSelectComponent implements OnInit {
    readonly step = ImportStep.OutcomeColumn;
    projectId: string;
    columns: ColumnForSelection[];
    selectedColumn: ColumnForSelection;
    haveFormula: boolean = true;

    loading = false;
    dataLoaded = false;
    
    @ViewChildren('columnRef') columnElements!: QueryList<ElementRef>;

    constructor(private dataService: DataService, private notifier: NotificationService, projectService: ProjectService, columnScrollService: ColumnScrollService) {
        super(projectService, columnScrollService);
    }

    public async loadDataInternal(): Promise<void> {
        const resp = await this.dataService.get<OutcomeColumnSelectionModel>('columnSelection/outcome/' + this.projectId);
        this.stepState = resp.stepState;
        if (this.stepState <= ImportStepState.NotAvailableYet) {
            return;
        }
        this.columns = resp.columns;
        this.haveFormula = resp.haveFormula;
        this.selectColumn(resp.columns.filter(c => c.isSelected)[0]);
        this.dataLoaded = true;
    }

    public columnClicked(column: ColumnForSelection): void {
        if (!column || !column.isEligible) {
            return;
        }
        this.selectOutcomeColumn(column);
    }

    private selectOutcomeColumn(column: ColumnForSelection): void {
        for (var i = 0; i < this.columns.length; ++i) {
            this.columns[i].isSelected = false;
        }
        column.isSelected = true;
        this.selectedColumn = column;
    }

    async save() {
        if(this.loading) {
            return;
        }
        try {
            this.loading = true;
            const url = this.haveFormula ? 'columnSelection/outcome' : 'columnSelection/outcomeNoFormula';
            const changesApplied = await this.dataService.post<boolean>(url, {
                projectId: this.projectId,
                columnIndex: this.columns.indexOf(this.selectedColumn),
            });
            this.finishStepSuccessfully(changesApplied, { haveFormula: this.haveFormula });
        }
        catch(ex) {
            let erroMsg: string;
            if (ex.error && ex.error.message) {
                erroMsg = ex.error.message;
            } else if (ex instanceof Error) {
                erroMsg = ex.message;
            } else {
                erroMsg = 'An unexpected error occurred.';
            }
            this.notifier.showError(erroMsg);
        }
        finally {
            this.loading = false;
        }
    }

    
}
